import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import useTrackPageView from '../../hooks/useTrackPageView';
import InputField from '../../components/ui/InputField/InputField';
import Button from '../../components/ui/Button/Button';
import DividerText from '../../components/ui/DividerText/DividerText';
import logoGoogle from '../../assets/google-icon.svg';
import { useToast } from '../../hooks/useToast';
import { mapSupabaseError } from '../../utils/mapSupabaseError';
import HeaderSecondLevel from '../../components/ui/Header/HeaderSecondLevel';
import supabase from '../../config/supabase';
import { trackEvent } from '../../hooks/useTrackPageView';
import { EVENTS } from '../../utils/amplitudeEvents';


function Register() {
  const { register, loginWithGoogle } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loadingForm, setLoadingForm] = useState(false);
  const navigate = useNavigate();
  const { showError, showSuccess } = useToast();
  const { setPendingEmail } = useAuth();


  useTrackPageView('register');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loadingForm) return;
    setLoadingForm(true);

    const redirectTo = process.env.REACT_APP_REDIRECT_URL;
    if (!redirectTo) {
      showError('Error interno de configuración. Intenta más tarde.');
      return;
    }
    trackEvent(EVENTS.REGISTER_ATTEMPTED_WITH_EMAIL, { email });

    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: { emailRedirectTo: redirectTo },
      });

      // 🧠 Guardamos el último email por UX
      localStorage.setItem('lastRegisteredEmail', email);
      setPendingEmail(email);

      console.log('error', error);

      if (error) {
        throw error;
      }
      trackEvent(EVENTS.REGISTER_SUCCESS, { email });

      showSuccess('Te hemos enviado un correo de verificación. Revisa tu bandeja de entrada para activar tu cuenta.');
      return navigate('/verify-email');

    } catch (err) {
      console.error('❌ Register error:', err.message);
      trackEvent(EVENTS.REGISTER_FAILED, {
        email,
        error: err.message,
      });

      if (err.message === 'rate_limit_exceeded') {
        showError('Has solicitado demasiados registros seguidos. Intenta de nuevo en unos minutos.');
      } else {
        showError(mapSupabaseError(err));
      }
    } finally {
      setLoadingForm(false);
    }
  };




  const handleBack = () => {
    navigate('/');

  };

  return (
    <>
      <HeaderSecondLevel
        showBackButton
        onBack={handleBack}
      />
      <div className="container auth-container">
        <div className="auth-content">
          <h1>Crea tu cuenta</h1>
          <div className="auth-body">
            <form className="auth-form" onSubmit={handleSubmit}>
              <InputField
                name="email"
                label="Email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                required
              />
              <InputField
                name="password"
                label="Contraseña"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                required
              />
              <Button
                label="Registrarme"
                variant="primary"
                size="lg"
                type="submit"
                isLoading={loadingForm}
                leftIcon
                disabled={!email || !password || loadingForm}
              />
            </form>

            <div className="auth-divider">
              <DividerText text="o" />
            </div>

            <Button
              label="Registro con Google"
              variant="outline"
              size="lg"
              leftIcon={<img src={logoGoogle} alt="Google" width="20" height="20" />}
              onClick={() => {
                trackEvent(EVENTS.REGISTER_ATTEMPTED_WITH_GOOGLE);
                loginWithGoogle();
              }} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
